/* eslint-disable-next-line import/extensions */
import NotificationEx from './src/main.js';
import NotificationComponentEx from './src/main.vue';

/* istanbul ignore next */
NotificationEx.install = function (Vue) {
  Vue.prototype.$notifyEx = NotificationEx;
  Vue.component(NotificationComponentEx.name, NotificationComponentEx);
};

export default NotificationEx;
